// import { Pipe, PipeTransform } from '@angular/core';

// @Pipe({ name: 'highlight', standalone: true })
// export class HighlightPipe implements PipeTransform {
//   transform(text: string | null | undefined, search: string): any {
//     if (!text) return text; // <-- Add this line (handles undefined/null/"")
//     if (!search) return text;
//     const pattern = search
//       .replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&')
//       .split(' ')
//       .filter((t) => t.length > 0)
//       .join('|');
//     const regex = new RegExp(pattern, 'gi');
//     return text.replace(regex, (match) => `<b>${match}</b>`);
//   }
// }

// import { Pipe, PipeTransform } from '@angular/core';

// @Pipe({ name: 'highlight', standalone: true })
// export class HighlightPipe implements PipeTransform {
//   transform(text: string | null | undefined, search: string): any {
//     console.log('Original text:', text);
//     console.log('Search term:', search);

//     if (!text || !search) return text;

//     const searchLower = search.toLowerCase();
//     const words = text.split(/(\s+)/); // Split and preserve spaces
//     console.log('Split words:', words);

//     const highlighted = words.map((word) => {
//       const wordLower = word.toLowerCase();
//       const index = wordLower.indexOf(searchLower);
//       console.log(
//         `Checking word: "${word}" | Lowercase: "${wordLower}" | Match index: ${index}`
//       );

//       if (index !== -1) {
//         const before = word.slice(0, index);
//         const match = word.slice(index, index + search.length);
//         const after = word.slice(index + search.length);
//         const result = `${before}<b>${match}</b>${after}`;
//         console.log(`Highlighting: "${result}"`);
//         return result;
//       }

//       return word;
//     });

//     const finalResult = highlighted.join('');
//     console.log('Final highlighted result:', finalResult);
//     return finalResult;
//   }
// }

// import { Pipe, PipeTransform } from '@angular/core';

// @Pipe({ name: 'highlight', standalone: true })
// export class HighlightPipe implements PipeTransform {
//   transform(text: string | null | undefined, search: string): any {
//     if (!text || !search) return text;

//     const searchLower = search.toLowerCase();
//     const words = text.split(/(\s+)/); // Preserve spaces

//     const highlighted = words.map((word) => {
//       // Split compound words by hyphen, underscore, etc.
//       const subParts = word.split(/[-_]/);
//       let transformedWord = word;

//       subParts.forEach((sub) => {
//         const subLower = sub.toLowerCase();

//         // Find longest common prefix
//         let matchLength = 0;
//         for (
//           let i = 0;
//           i < Math.min(subLower.length, searchLower.length);
//           i++
//         ) {
//           if (subLower[i] === searchLower[i]) {
//             matchLength++;
//           } else {
//             break;
//           }
//         }
//         if (matchLength >= 4) {
//           const before = sub.slice(0, matchLength);
//           const after = sub.slice(matchLength);
//           const highlightedSub = `<b>${before}</b>${after}`;

//           // Replace only the matched subword in the original word
//           transformedWord = transformedWord.replace(sub, highlightedSub);
//         }
//       });

//       return transformedWord;
//     });

//     const finalResult = highlighted.join('');
//     return finalResult;
//   }
// }

// import { Pipe, PipeTransform } from '@angular/core';

// @Pipe({ name: 'highlight', standalone: true })
// export class HighlightPipe implements PipeTransform {
//   transform(text: string | null | undefined, search: string): any {
//     if (!text || !search) return text;

//     const searchTerms = search
//       .split(/\s+/) // Split by spaces
//       .map((term) => term.toLowerCase())
//       .filter((term) => term.length >= 4); // Only consider terms with length >= 4

//     const words = text.split(/(\s+)/); // Preserve spaces

//     const highlighted = words.map((word) => {
//       const subParts = word.split(/[-_]/);
//       let transformedWord = word;

//       subParts.forEach((sub) => {
//         const subLower = sub.toLowerCase();

//         searchTerms.forEach((searchLower) => {
//           let matchLength = 0;
//           for (
//             let i = 0;
//             i < Math.min(subLower.length, searchLower.length);
//             i++
//           ) {
//             if (subLower[i] === searchLower[i]) {
//               matchLength++;
//             } else {
//               break;
//             }
//           }

//           if (matchLength >= 4) {
//             const before = sub.slice(0, matchLength);
//             const after = sub.slice(matchLength);
//             const highlightedSub = `<b>${before}</b>${after}`;

//             // Replace only the matched subword in the original word
//             transformedWord = transformedWord.replace(sub, highlightedSub);
//           }
//         });
//       });

//       return transformedWord;
//     });

//     return highlighted.join('');
//   }
// }

import { Pipe, PipeTransform } from '@angular/core';

// @Pipe({ name: 'highlight', standalone: true })
// export class HighlightPipe implements PipeTransform {
//   transform(text: string | null | undefined, search: string): any {
//     if (!text || !search) return text;

//     const searchTerms = search
//       .split(/\s+/)
//       .map((term) => term.toLowerCase())
//       .filter((term) => term.length >= 4);

//     const words = text.split(/(\s+)/); // Preserve spaces

//     const highlighted = words.map((word) => {
//       const subParts = word.split(/[-_]/);
//       let transformedWord = word;

//       subParts.forEach((sub) => {
//         const subLower = sub.toLowerCase();

//         searchTerms.forEach((searchLower) => {
//           let matchLength = 0;
//           for (
//             let i = 0;
//             i < Math.min(subLower.length, searchLower.length);
//             i++
//           ) {
//             if (subLower[i] === searchLower[i]) {
//               matchLength++;
//             } else {
//               break;
//             }
//           }

//           if (matchLength >= 4) {
//             const before = sub.slice(0, matchLength);
//             const after = sub.slice(matchLength);
//             const highlightedSub = `<b>${before}</b>${after}`;

//             // Replace only the matched subword in the original word
//             const regex = new RegExp(sub, 'g');
//             transformedWord = transformedWord.replace(regex, highlightedSub);
//           }
//         });
//       });

//       return transformedWord;
//     });

//     return highlighted.join('');
//   }
// }

function escapeRegExp(str: string): string {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

@Pipe({ name: 'highlight', standalone: true })
export class HighlightPipe implements PipeTransform {
  transform(text: string | null | undefined, search: string): any {
    if (!text || !search) return text;

    const searchTerms = search
      .split(/\s+/)
      .map((term) => term.toLowerCase())
      .filter((term) => term.length >= 4);

    const words = text.split(/(\s+)/); // Preserve spaces

    const highlighted = words.map((word) => {
      const subParts = word.split(/[-_]/);
      let transformedWord = word;

      subParts.forEach((sub) => {
        const subLower = sub.toLowerCase();

        searchTerms.forEach((searchLower) => {
          let matchLength = 0;
          for (
            let i = 0;
            i < Math.min(subLower.length, searchLower.length);
            i++
          ) {
            if (subLower[i] === searchLower[i]) {
              matchLength++;
            } else {
              break;
            }
          }

          if (matchLength >= 4) {
            const before = sub.slice(0, matchLength);
            const after = sub.slice(matchLength);
            const highlightedSub = `<b>${before}</b>${after}`;

            // Escape regex special characters in sub
            const regex = new RegExp(escapeRegExp(sub), 'g');
            transformedWord = transformedWord.replace(regex, highlightedSub);
          }
        });
      });

      return transformedWord;
    });

    return highlighted.join('');
  }
}
